import { connectIndexedDB, createRepository } from '../libs/indexedDB';

const USER_ACTION = {
  VIEW_PRODUCT: 'view_product',
  VIEW_PRODUCT_PRE_ORDER: 'view_product_pre_order',
  QUICK_VIEW: 'quick_view',
  ADD_TO_CART: 'add_to_cart',
  BUY_NOW: 'buy_now',
  ATC_PRE_ORDER: 'add_to_cart_pre_order',
};

const BOOST_CART_TOKEN = {
  PREFIX: 'bct-',
  SHORT_KEY: 'bct',
};

const db = connectIndexedDB({
  version: 1,
  tables: {
    events: {
      keyPath: 'id',
      autoIncrement: true,
      indexes: [
        {
          name: 'status',
          keyPath: 'status',
          options: { unique: false },
        },
      ],
    },
  },
});

const eventsRepository = createRepository('events');

async function sendEventHandler(eventData) {
  let retry = 0;
  const maxRetries = 5;

  const refreshCartTokenSendEvent = async (data, extraData) => {
    try {
      const response = await fetch(extraData.cartUrl, {
        method: 'GET',
      });

      const toJson = await response.json();

      if (!toJson?.attributes?.[BOOST_CART_TOKEN.SHORT_KEY] && retry < maxRetries) {
        retry++;
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              [BOOST_CART_TOKEN.SHORT_KEY]: extraData.newBoostCartToken,
            },
          }),
        })
          .then((r) => r.json())
          .catch((error) => {
            console.error('Error creating/updating Boost cart token:', error);
          });

        return refreshCartTokenSendEvent(data, extraData);
      }

      // push all add to cart if have - not check duplicate token
      if (toJson?.attributes?.[BOOST_CART_TOKEN.SHORT_KEY]) {
        data.ct = toJson.token;
        data[BOOST_CART_TOKEN.SHORT_KEY] = toJson.attributes[BOOST_CART_TOKEN.SHORT_KEY];
        await postData(extraData.ANALYTICS_URL, data, extraData);
      }
    } catch (error) {
      console.log('refreshCartTokenSendEvent', error?.stack);
    }
  };

  const { sessionId, payload } = eventData;

  const { data, extraData } = payload || {};

  try {
    // if cartToken not existed -> get cart -> sendEvent
    if (
      [USER_ACTION.ADD_TO_CART, USER_ACTION.BUY_NOW, USER_ACTION.ATC_PRE_ORDER].includes(data.u)
    ) {
      await refreshCartTokenSendEvent(data, extraData, (data) => postMessage(data));
    } else {
      await postData(extraData.ANALYTICS_URL, data, extraData, (data) => postMessage(data));
    }

    postMessage({ sessionId, success: true });
  } catch (error) {
    postMessage({ sessionId, success: false, error: error.message, payload });
  }
}

const validateData = (data) => {
  // check if productId not correct format => re-assign empty string
  if (data.pid && isNaN(data.pid)) {
    data.pid = '';
  }

  return data;
};

const postData = async (url = '', data = {}, extraData = {}) => {
  const { productIdsClicked } = extraData || {};

  if (
    !data.rid ||
    (data.pid && data.u === USER_ACTION.ADD_TO_CART && !productIdsClicked[data.pid])
  ) {
    return;
  }

  data = validateData(data);

  // For set timeout to reproduce error
  // const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  // await wait(2000);

  const sendData = () => {
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  };

  await sendData();
};

self.addEventListener('message', async (e) => {
  try {
    const { payload } = e.data;
    const { action } = payload || {};

    if (action === 'sendEvent') {
      const eventId = await eventsRepository.add({ data: e.data, status: 'pending' });

      await sendEventHandler(e.data);

      eventsRepository.update(eventId, { status: 'success' });
      return;
    }

    postMessage({ sessionId: e.data.sessionId, success: false, error: 'Invalid action' });
  } catch (error) {
    postMessage({
      sessionId: e.data.sessionId,
      success: false,
      error: error.message,
      payload: e.data.payload,
    });
  }
});

const interval = setInterval(async () => {
  if (db) {
    clearInterval(interval);
    // Lookup events, if pending, send them otherwise delete them
    const pendingEvents = await eventsRepository.find({ status: 'pending' });
    if (pendingEvents.length) {
      pendingEvents.forEach(async (event) => {
        await sendEventHandler(event.data);
        await eventsRepository.update(event.id, { status: 'success' });
      });
    }
    // If total events > 100, remove 50 oldest events, LIFO
    const allEvents = await eventsRepository.find({});
    if (allEvents.length > 100) {
      const eventsToRemove = allEvents.sort((a, b) => a.id - b.id).slice(0, 50);
      for (const event of eventsToRemove) {
        await eventsRepository.delete(event.id);
      }
    }
  }
}, 50);
